import Vue from 'vue'
import utilService from "@/service/utilService";
import moment from 'moment-timezone';

function registerGlobalFilters() {
    Vue.filter('calendar', function (isoString) { // '2023-12-20T13:48:54.899Z' ISO 형식의 문자열만 허용
        if (!isoString) {
            return isoString;
        }

        const date = moment(isoString);
        return date.isValid()
            ? date.calendar(null, {
                sameDay: '[오늘] A hh:mm',
                nextDay: '[내일] A hh:mm',
                nextWeek: 'YYYY-MM-DD A hh:mm',
                lastDay: '[어제] A hh:mm',
                lastWeek: 'YYYY-MM-DD A hh:mm',
                sameElse: 'YYYY-MM-DD A hh:mm'
            })
            : isoString;
    });

    Vue.filter('phone', function(str) {
        return str ? utilService.humanReadableMobile(str) : str;
    })
}

export default registerGlobalFilters;